import { IGeoSchema } from '../types';

const MOSCOW_OBL_ID = 4593;

export const getLocationIds = (geo?: IGeoSchema) => {
  if (!geo || !geo.address || !Array.isArray(geo.address.details)) {
    return [0, 0, 0];
  }
  const { details } = geo.address;

  const locationIds = details
    .filter(item => item.type === 'location')
    .map(item => item.id)
    .filter(Boolean) as number[];

  // moId = 1 для MVP.
  const result: number[] = [1];

  if (locationIds.length) {
    // Если это Московская область, то передаем айди района, то есть, второй элемент массива.
    if (locationIds[0] === MOSCOW_OBL_ID) {
      result.push(locationIds[1]);
    } else {
      result.push(locationIds[0]);
    }
    result.push(locationIds[locationIds.length - 1]);
  }

  return result;
};
